<script>
/**
 * Forgot Password component
 */
export default {
    data() {
        return {
            isResetError: false
        };
    },
    mounted() {
        this.isResetError = !!this.error;
    },
    props: {
        submitUrl: {
            type: String,
            required: true
        },
        email: {
            type: String,
            required: false,
            default: () => null
        },
        error: {
            type: String,
            required: false,
            default: () => null
        }
    }
};
</script>

<template>
<div class="row justify-content-center">
    <div class="col-md-8 col-lg-6 col-xl-5">
        <h2 class="text-center text-primary">Plataforma Evaluación Red Inmaculada Concepción</h2>
        <div class="card overflow-hidden">
            <div class="bg-soft-primary">
                <div class="row p-3">
                    <div class="col-4 text-center">
                        <img src="/images/imagenes/logo.png" alt height="100" />
                    </div>
                    <div class="col-8 text-center">
                        <div class="text-primary">
                            <h4 class="text-primary">Crear Nueva Contraseña</h4>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body pt-0">
                <div class="p-2">
                    <b-alert v-model="isResetError" class="mb-4" variant="danger" dismissible>{{error}}</b-alert>
                    <form :action="submitUrl" method="POST">
                        <slot />
                        <div class="form-group">
                            <label for="useremail">Correo Electrónico</label>
                            <input type="email" name="email" :value="email" class="form-control" id="useremail" placeholder="Ingresar Correo" />
                        </div>
                        <b-form-group id="password-group" label="Nueva Contraseña" label-for="password">
                            <b-form-input
                                id="password"
                                name="password"
                                type="password"
                                placeholder="Ingresar Nueva Contraseña"
                            ></b-form-input>
                            </b-form-group>
                            <b-form-group label="Confirmar Contraseña" label-for="password-confirm">
                            <b-form-input
                                id="password-confirm"
                                name="password_confirmation"
                                type="password"
                                placeholder="Confirmar Contraseña"
                            ></b-form-input>
                            </b-form-group>
                        <div class="form-group row mb-0">
                            <div class="col-12 text-right">
                                <button class="btn btn-primary w-md" type="submit">Crear Contraseña</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
            <p>
                ¿Ya tienes contraseña?
                <a href="/login" class="font-weight-medium text-primary">Inicia sesión aquí</a>
            </p>
            <p>
                © {{ new Date().getFullYear() }} Red IC
            </p>
        </div>
    </div>
    <!-- end col -->
</div>
</template>